export default __webpack_public_path__ + "static/media/mana2.5faf2d1d.svg";